import Shepherd from "shepherd.js";
import {getScreenSize} from "../helpers/screens";
import * as userActions from "../actions/user";
import {connect} from "redux-vue";

const tour = new Shepherd.Tour({
  useModalOverlay: true,
  defaultStepOptions: {
    scrollTo: {
      behavior: "smooth",
      block: "center",
    },
    showCancelLink: true,
    classes: "shepherd-theme-custom"
  },
  styleVariables: {
    shepherdButtonBorderRadius: "15px",
    shepherdElementBorderRadius: "1px",
    shepherdThemePrimary: "#3182ce",
    shepherdThemeTextPrimary: "#FFF"
  }
});

/**
 *
 */
const CoursePageTour = {
  props: [
    'user', 'module', 'setTour',
    '$playbackWindow', '$activeLessonItem', '$menuToggle', '$commentsContainer', '$resourcesContainer', '$askExpertContainer',
    'finishHandler', 'initHandler'],

  mounted() {
    if (this.module.model) {
      this.initializeTour();
    }
  },

  watch: {
    module(nextVal, val) {
      if (!val.model && nextVal.model) {
        this.initializeTour();
      }
    }
  },

  methods: {
    /**
     *
     */
    initializeTour() {
      if (!this.user.model.tour) {
        const tourFinishHandler = () => {
          this.setTour(1);
          if(typeof this.finishHandler === 'function') {
            this.finishHandler();
          }
          this.$nextTick(() => {
            document
              .querySelector(this.$playbackWindow)
              .scrollIntoView({ behavior: "smooth", block: "center" });
          });
        };

        if(typeof this.initHandler === 'function') {
          this.initHandler();
        }
        this.addSteps();
        tour.start();
        tour.on("complete", tourFinishHandler);
        tour.on("cancel", tourFinishHandler);
      }
    },

    /**
     *
     */
    addSteps() {
      tour.addStep({
        id: "start-step",
        text: this.$t('tour.start_step'),
        classes: "shepherd-theme-custom shepherd-theme-custom-start",
        buttons: [
          {
            text: this.$t('tour.tour_btn_text'),
            action: tour.next
          }
        ]
      });

      tour.addStep({
        id: "playback-step",
        text: this.$t('tour.playback_step_1'),
        attachTo: {
          element: this.$playbackWindow,
          on: getScreenSize() === "sm" ? "top" : "right"
        },
        buttons: [
          {
            action () {
              return this.back();
            },
            classes: "shepherd-button-secondary",
            text: this.$t('tour.back_btn_text'),
          },
          {
            text: this.$t('tour.next_btn_text'),
            action: tour.next
          }
        ]
      });

      tour.addStep({
        id: "playback-step",
        text: this.$t('tour.playback_step_2') + '<br><br><img src="/img/tour/next_button.jpg">',
        buttons: [
          {
            action () {
              return this.back();
            },
            classes: "shepherd-button-secondary",
            text: this.$t('tour.back_btn_text'),
          },
          {
            text: this.$t('tour.next_btn_text'),
            action: tour.next
          }
        ]
      });

      tour.addStep({
        id: "playback-step",
        text: this.$t('tour.playback_step_3'),
        attachTo: {
          element: this.$activeLessonItem,
          on: "bottom-end"
        },
        buttons: [
          {
            action () {
              return this.back();
            },
            classes: "shepherd-button-secondary",
            text: this.$t('tour.back_btn_text'),
          },
          {
            text: this.$t('tour.next_btn_text'),
            action: tour.next
          }
        ]
      });

      tour.addStep({
        id: "collaborate-step",
        text: getScreenSize() === "sm"
          ? this.$t('tour.collaborate_step_1_sm')
          : this.$t('tour.collaborate_step_1_lg'),
        attachTo: {
          element: this.$menuToggle,
          on: getScreenSize() === "sm" ? "bottom" : "right"
        },
        buttons: [
          {
            action () {
              return this.back();
            },
            classes: "shepherd-button-secondary",
            text: this.$t('tour.back_btn_text'),
          },
          {
            text: this.$t('tour.next_btn_text'),
            action: tour.next
          }
        ]
      });

      tour.addStep({
        id: "collaborate-step",
        text: this.$t('tour.collaborate_step_2'),
        attachTo: {
          element: this.$commentsContainer,
          on: "top"
        },
        scrollToHandler: function (element) {
          const headerOffset = 300;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
        },
        buttons: [
          {
            action () {
              return this.back();
            },
            classes: "shepherd-button-secondary",
            text: this.$t('tour.back_btn_text'),
          },
          {
            text: this.$t('tour.next_btn_text'),
            action: tour.next
          }
        ]
      });

      tour.addStep({
        id: "collaborate-step",
        text: this.$t('tour.collaborate_step_3'),
        attachTo: {
          element: this.$resourcesContainer,
          on: getScreenSize() === "sm" ? "top" : "left"
        },
        scrollTo: {
          behavior: "smooth",
          block: "nearest"
        },
        buttons: [
          {
            action () {
              return this.back();
            },
            classes: "shepherd-button-secondary",
            text: this.$t('tour.back_btn_text'),
          },
          {
            text: this.$t('tour.next_btn_text'),
            action: tour.next
          }
        ]
      });

      tour.addStep({
        id: "collaborate-step",
        text: this.$t('tour.collaborate_step_4'),
        attachTo: {
          element: this.$askExpertContainer,
          on: getScreenSize() === "sm" ? "top" : "left"
        },
        scrollTo: {
          behavior: "smooth",
          block: "nearest"
        },
        buttons: [
          {
            action () {
              return this.back();
            },
            classes: "shepherd-button-secondary",
            text: this.$t('tour.back_btn_text'),
          },
          {
            text: this.$t('tour.done_btn_text'),
            action: tour.next
          }
        ]
      });
    }
  },

  render(h) {
    return null;
  }
};

function mapStateToProps(state) {
  return {
    user: state.user,
    module: state.module,
  };
}

function mapActionToProps(dispatch) {
  return {
    setTour: tour => dispatch(userActions.setTour(tour))
  };
}

export default connect(mapStateToProps, mapActionToProps)(CoursePageTour);